import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserLock } from '@fortawesome/free-solid-svg-icons';
import { lockUser as lockUserApi } from "../../../../../api/clients/users";
import { Link } from "react-router-dom";
import {
  ACL,
  USER_DELETE_STATUSES,
  USER_STATUSES
} from "../../../../../config/constants";
import { NOTIFICATION_CLIENT_ACTIONS } from '../../../../../config/notifications';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function LockClient(props) {
  const [showLockModal, setShowLockModal] = useState(false);

  if (! ACL.CLIENT.USERS.LOCK.hasAccess()) {
    return null;
  }

  const {index, actionCallback, user, showIcon} = props;

  const lockUser = () => {
    lockUserApi({
      userId: user.id,
      notificationId: NOTIFICATION_CLIENT_ACTIONS
    }).then((response) => {
      setShowLockModal( false );

      if (response && response.status === 200) {
        actionCallback();
      }
    });
  };

  const shouldDisplay = (user) => {
    return (!user || USER_DELETE_STATUSES.includes(user.status) || user.status === USER_STATUSES.INACTIVE) ? false : true;
  }

  if (! shouldDisplay(user)) {
    return null;
  }

  return (<Fragment>
      {!showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`lock-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowLockModal(true)
            }}
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.lock_user"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`lock-icon-${index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.lock_user"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`lock-icon-` + props.index}
            onClick={() => setShowLockModal(true)}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faUserLock}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`lock-icon-${props.index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.lock_user"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showLockModal}
        closeModal={() => setShowLockModal(false)}
        confirmationYes={lockUser}
        messageId="components.layout.confirmation.body.lock_user"
      />
    </Fragment>
  );
}

export { LockClient };
